export default __webpack_public_path__ + "static/media/logo-white-panews.4737a782.webp";